<template>
  <div
    v-if="!loading"
    class="fill-height">
    <Stepper 
      :fetchedContract="contract" /> 
  </div>
</template>

<script>
import Stepper from '@/components/contracts/create/Stepper'
import { Contract } from '@/graphql/queries/contract'

export default {
  data: () => ({
    contract: {
      id: null
    },
    loading: true,
  }),

  created () {
    if (this.$route.params.id) {
      this.fetchContract()
    } else {
      this.loading = false
    }
  },

  methods:{
    fetchContract() {
      this.$apollo.query({
        query: Contract,
        variables: {
          id: this.$route.params.id
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        this.contract = res.data.contract

        this.$nextTick ( () => {
          this.loading = false
        })
      })
    }
  },

  components: {
    Stepper
  },
}
</script>

<style @scoped>
.v-stepper__wrapper {
  height: 100% !important;
  padding: 0px 9px;
}
</style>
